import { getMessageType } from '@bundles/Messages/helpers';
import { INBOX_TYPE, MESSAGE_STATUS } from '@constants/messages';
import { OFFSET_MULTIPLIER, PAGE_NORMALIZER } from '@constants/pagination';
import { removeUndefined } from '@helpers/object';

/**
 * @typedef MessagesRequestModel
 * @prop {string} archived 'true' for archived messages
 * @prop {string} dateFrom Start date filter
 * @prop {string} dateTo End date filter
 * @prop {string} messagingType Message type
 * @prop {string|number} offset Record to start at
 * @prop {string} savedPeriodId Filing period ID
 * @prop {string} search Search query
 * @prop {string} status Status filter. Read and/or unread in comma separated list
 */

/**
 * Transform data for message list API request
 * @param {Object} $0 Payload
 * @param {string|number} $0.page Page number
 * @param {string} $0.category Message category
 * @param {string} $0.inbox Messages inbox
 * @param {string} $0.dateFrom Start date filter
 * @param {string} $0.dateTo End date filter
 * @param {string|number} [$0.limit=20] Results per page
 * @param {string} $0.search Search query
 * @param {string} $0.status Status filter (read/unread)
 * @param {string} $0.savedFilingPeriod Filing period ID
 * @returns {MessagesRequestModel} Transformed data
 */
export const messageListRequestModel = ({
  category,
  dateFrom,
  dateTo,
  inbox,
  limit = OFFSET_MULTIPLIER,
  page,
  savedFilingPeriod,
  search,
  status,
}) =>
  removeUndefined({
    archived: inbox === INBOX_TYPE.ARCHIVE || false,
    dateFrom,
    dateTo,
    limit,
    messagingType: getMessageType(category),
    offset: (page || PAGE_NORMALIZER) * limit - limit,
    savedPeriodId: savedFilingPeriod,
    search,
    status: status?.replace('Unread', MESSAGE_STATUS.UN_READ),
  });
